module.exports = __webpack_public_path__ + "SourceSans3-ExtraLightIt.otf.f02bc.woff";